import { Component, OnInit, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

import { listMockParticipants } from 'src/app/core/constants/team-management-const';
import { WindowScrollService } from 'src/app/core/services/window-scroll.service';

interface Item {
  id: string;
  name?: string;
  nickname?: string;
  option?: string;
  select?: boolean;
}

@Component({
  selector: 'app-participants-modal',
  templateUrl: './participants-modal.component.html',
  styleUrls: ['./participants-modal.component.scss']
})
export class ParticipantsModalComponent implements OnInit {

  public listHeaders = [
    {
      id: 1,
      nameClass: 'name',
      data: 'input',
    },
    {
      id: 2,
      nameClass: 'product',
      data: 'Nome',
    },
    {
      id: 3,
      nameClass: 'contact',
      data: 'Empresa',
    }
  ];
  public autocompleteTeamMembers: any[];

  public listBinding = listMockParticipants;
  public isOpenMenu = false;

  public selectedParticipants = [];
  public removingParticipant = false;
  public removingParticipantList = [];

  @HostListener('document:click', ['$event'])
  onClick(ev: Event) {
    if (this.isOpenMenu) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.isOpenMenu = false;
      }
    }
  }

  constructor(
    private scroll: WindowScrollService,
    private eRef: ElementRef,
  ) {
  }

  @Output() closeModal = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.scroll.disable();
    this.useMock();
  }

  useMock(): void {
    this.autocompleteTeamMembers = [
      { id: 'mock', name: 'mock' }
    ];
  }

  clearBody() {
    this.scroll.enable();
    this.closeModal.emit(false);
  }

  public actionsParticipants(): void {
    this.isOpenMenu = false;
    this.selectedParticipants = Array.from(this.selectedParticipants);
    this.removingParticipant = false;
  }

  sendParticipants(data: Item) {
    if (data.option === 'Remover') {
      this.removingParticipantList = [{ id: data.id, name: data.name, nickname: data.nickname }];
      this.removingParticipant = true;
    }
  }

  sendIndex(data) {
  }

  sendItemSelections(data: Item) {
    this.removingAndAdd(data, this.selectedParticipants);
  }

  public sendAllSelections(data: Item) {
    if (data.select) {
      this.selectedParticipants.push(data);
    } else {
      this.selectedParticipants = [];
    }
  }

  public removingAndAdd(data: Item, list: Item []): void {
    if (data.select) {
      list.push(data);
    } else {
      list.splice(list.indexOf(data), 1);
    }
  }

}